<div
  *ngIf="name"
  [class.icon-small]="size === 32"
  class="icon {{ color }}"
  [style.background-image]="'url(/assets/img/icon/' + name + '.svg' + ')'"
  [ngClass]="{ small: small }"
></div>
